import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import efafcImage from '../../assets/efafc_prov.jpg';
import efafcLogo from '../../assets/efafc.png';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleClubRedirect = () => {
    navigate('/club');
  };

  const handleScroll = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <section className="w-full min-h-[100vh] flex items-center justify-center px-4 py-10 relative -mt-16 z-0 pt-28">
      <div className="relative w-full h-full rounded-3xl overflow-hidden shadow-xl">
        {/* Background Image */}
        <motion.img
          initial={{ scale: 1.1, filter: "blur(2px)" }}
          animate={{ scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          src={efafcImage}
          alt="EF-AFC Banner"
          className="w-full h-[92vh] object-cover rounded-3xl"
        />

        {/* Gradient Overlay - Plus dramatique */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#001B56]/90 via-black/50 to-black/30 rounded-3xl" />

        {/* Contenu centré */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-8">
          {/* Logo avec effet halo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative mb-6"
          >
            <div className="absolute inset-0 bg-[#FFE400]/20 blur-3xl rounded-full scale-150" />
            <img
              src={efafcLogo}
              alt="EFAFC Logo"
              className="relative h-24 sm:h-32 md:h-40 w-auto drop-shadow-2xl"
            />
          </motion.div>

          {/* Nom du club */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
            className="font-title text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#FFE400] leading-tight mb-4 drop-shadow-lg"
          >
            ENTENTE FEIGNIES
            <br />
            AULNOYE FC
          </motion.h1>

          {/* Slogan */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="font-accent text-white/90 text-lg sm:text-xl md:text-2xl tracking-widest uppercase mb-8"
          >
            Ensemble, plus forts
          </motion.p>

          {/* Bouton CTA */}
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
            whileHover={{ scale: 1.05, boxShadow: "0 10px 40px rgba(255, 228, 0, 0.4)" }}
            whileTap={{ scale: 0.95 }}
            onClick={handleClubRedirect}
            className="bg-gradient-to-r from-[#FFE400] to-[#BDFF00] text-[#001B56] font-accent font-bold px-10 py-4 rounded-full text-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
          >
            Découvrir le club
          </motion.button>
        </div>

        {/* Indicateur de scroll */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer"
          onClick={handleScroll}
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            className="flex flex-col items-center text-white/60 hover:text-white/80 transition-colors"
          >
            <ChevronDown size={28} className="mb-0" />
            <ChevronDown size={28} className="-mt-4" />
            <span className="font-accent text-xs mt-1 tracking-wider">DÉFILER</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
